import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ShieldAlert, ShieldCheck } from "lucide-react";

/**
 * Shows last successful login + recent failed attempts as a soft banner.
 * Auto-loads /api/auth/login-activity. Hide when no data.
 */
export default function LoginActivityAlert() {
  const [activity, setActivity] = useState(null);

  useEffect(() => {
    api.get("/auth/login-activity").then(({ data }) => setActivity(data)).catch(() => {});
  }, []);

  if (!activity) return null;
  const last = activity.last_success;
  const failures = activity.recent_failures || [];

  return (
    <div className="surface-card p-4 flex items-start gap-3" data-testid="login-activity-alert">
      {failures.length > 0
        ? <ShieldAlert className="w-5 h-5 text-amber-500 mt-0.5" />
        : <ShieldCheck className="w-5 h-5 text-emerald-600 mt-0.5" />}
      <div className="flex-1 text-sm">
        {last ? (
          <div>
            Last successful sign-in: <span className="font-semibold">{new Date(last.created_at).toLocaleString()}</span> from <span className="font-mono text-xs">{last.ip || "unknown IP"}</span>.
          </div>
        ) : (
          <div>This is your first sign-in here.</div>
        )}
        {failures.length > 0 && (
          <div className="text-amber-700 mt-1">
            {failures.length} recent failed attempt(s) — last on {new Date(failures[0].created_at).toLocaleString()} from {failures[0].ip || "unknown IP"}.
            If that wasn’t you, change your password and review active sessions immediately.
          </div>
        )}
      </div>
    </div>
  );
}
